import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { UserProfile } from '../../../models';
import { AuthService } from '../../../../core/services/auth.service';
import { NotificationDropdownComponent } from '../../ui/notification-dropdown/notification-dropdown.component';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, ButtonModule, MenuModule, OverlayBadgeModule, NotificationDropdownComponent],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
})
export class PageHeaderComponent {
  @Input() greeting: string = '';
  @Input() userProfile!: UserProfile;
  @Input() showHamburger: boolean = true;

  @Output() sidebarToggle = new EventEmitter<void>();

  userMenuItems = [
    {
      label: 'Settings',
      icon: 'pi pi-cog',
      command: () => this.navigateToSettings(),
    },
    {
      separator: true,
    },
    {
      label: 'Sign Out',
      icon: 'pi pi-sign-out',
      command: () => this.signOut(),
    },
  ];

  constructor(private authService: AuthService, private router: Router) {}

  toggleSidebar() {
    this.sidebarToggle.emit();
  }

  private navigateToProfile() {
    // Add navigation logic here
  }

  private navigateToSettings() {
    this.router.navigate(['/account']);
  }

  private signOut() {
    this.authService.logout();
    this.router.navigate(['/sign-in']);
  }
}
